export enum DividendStatus {
    PENDING_CONFIRMATION = 'pending_confirmation',
    CONFIRMED = 'confirmed',
}
